<button [class]="buttonClass"
  [disabled]="disabled"
  (click)="toggleFilter($event)"
  [tooltipDisabled]="disabledTooltip"
  pTooltip="{{tooltipText}}"
  [tooltipPosition]="tooltipPosition">
    <i [class]="'common-icon__md ' + icon"></i>
</button>
<p-tieredMenu #tieredMenuActionSelected
  styleClass="common-dropdown-list__a-container-visibility"
  [appendTo]="'body'"
  [model]="item.expandedMenu"
  (onShow)="configureMenu()"
  (onHide)="item.openMenuAction = false"
  [autoDisplay]="true"
  [popup]="true">
  <ng-template pTemplate="action"
    let-optionAction
    let-hasSubmenu="hasSubmenu">
    <button [class]="buttonOptionClass"
      (click)="launchAction(optionAction.action, optionAction)"
      [disabled]="optionAction.disabled">
      @if(optionAction.icon){
        <i [class]="optionAction.icon + ' common-icon__md'"></i>
      }
      <span-tooltip class="common-dropdown-list__si-text-container"
        [text]="optionAction[type] | afTranslate"
        [tooltipPosition]="'top'"
        [multiline]="multiline"></span-tooltip>
        @if (hasSubmenu) {
          <i class="lf-icon-angle-right common-icon__sm common-dropdown-list__a-icon-submenu"></i>
        }
    </button>
  </ng-template>
</p-tieredMenu>
